module.exports = __webpack_public_path__ + "src/assets/games/1/23.jpg";